import React, { useState, useEffect } from "react";
import styles from "../../../../styles/gri/general.module.css";


const SectionHeading = ({ text,marginBottom, sx }) => (
    <p
      className={styles.ques_heading}
      style={{
        marginTop: "1rem",
        marginLeft: "0",
        paddingLeft: "1rem",
        textIndent: "-1rem",
        lineHeight: "1.5",
        marginBottom:marginBottom || "10px",
        ...sx,
      }}
    >
      {text}
    </p>
  );

  export default SectionHeading;